module.exports = "https://www.gc-qa.gnp.com.mx/d1be17a695e1e5ed0817e6ea5f948309.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/video_volver.svg
// module id = 700
// module chunks = 0 1